import React, { useMemo } from 'react';
import ReviewCard from './ReviewCard';
import Pagination from './Pagination';

function ReviewFeed({ reviews, stats, pagination, loading, pageLoading, error, plate, stateCode, onPageChange, browsing }) {
  const reviewCards = useMemo(() => (
    reviews.map((review) => (
      <ReviewCard key={review.id} review={review} showOwnershipBadge />
    ))
  ), [reviews]);

  if (loading) {
    return (
      <div className="space-y-4">
        {[...Array(3)].map((_, index) => (
          <div key={index} className="animate-pulse rounded-[28px] bg-white p-8 shadow-sm border border-slate-200 h-52" />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-[28px] border border-rose-200 bg-rose-50 p-8 text-rose-900 shadow-sm">
        <h2 className="text-lg font-semibold">Unable to load reviews</h2>
        <p className="mt-3 text-sm text-rose-700">{error}</p>
      </div>
    );
  }

  if (!browsing && (!plate || !stateCode)) {
    return (
      <div className="rounded-[28px] border border-slate-200 bg-white p-8 shadow-sm">
        <h2 className="text-xl font-semibold text-slate-900">Start by searching a plate</h2>
        <p className="mt-3 text-sm leading-6 text-slate-600">Enter the vehicle plate and state to browse matching reviews in the feed.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {reviews.length === 0 ? (
        <div className="rounded-[28px] border border-slate-200 bg-white p-8 shadow-sm">
          <h2 className="text-xl font-semibold text-slate-900">No reviews found</h2>
          <p className="mt-3 text-sm leading-6 text-slate-600">
            {browsing
              ? 'No approved reviews found.'
              : `No approved reports exist for ${plate} - ${stateCode}. Submit the first review.`}
          </p>
        </div>
      ) : (
        <>
          <div className="space-y-6">{reviewCards}</div>

          <Pagination pagination={pagination} onPageChange={onPageChange} loading={pageLoading} />
        </>
      )}
    </div>
  );
}

export default React.memo(ReviewFeed);
